import React from "react";

import DashboardV2 from "./DashboardV2";
import DashboardV1 from "./DashboardV1";

export default function Dashboard(props) {
  return <DashboardV2 />;
}
